"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultOptions = {
  separatorCharacters: [".", "．", "。", "?", "!", "？", "！" // (ja) zenkaku exclamation mark
  ]
};
/**
 * Separator parser
 */

var SeparatorParser =
/** @class */
function () {
  function SeparatorParser(options) {
    this.options = options;
    this.separatorCharacters = options && options.separatorCharacters ? options.separatorCharacters : exports.DefaultOptions.separatorCharacters;
  }

  SeparatorParser.prototype.test = function (sourceCode) {
    if (sourceCode.isInContext()) {
      return false;
    }

    if (sourceCode.isInContextRange()) {
      return false;
    }

    var firstChar = sourceCode.read();
    var nextChar = sourceCode.read(1);

    if (!firstChar) {
      return false;
    }

    if (!this.separatorCharacters.includes(firstChar)) {
      return false;
    } // Need space after period
    // Example: "This is a pen. This is not a pen."
    // It will avoid false-position like `1.23`


    if (firstChar === ".") {
      if (nextChar) {
        return /[\s\t\r\n]/.test(nextChar);
      } else {
        return true;
      }
    }

    return true;
  };

  SeparatorParser.prototype.seek = function (sourceCode) {
    while (this.test(sourceCode)) {
      sourceCode.peek();
    }
  };

  return SeparatorParser;
}();

exports.SeparatorParser = SeparatorParser;